import { Platform } from 'react-native';

// Base spacing values
const baseSpacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

// Responsive spacing - tighter on mobile, more spacious on web
export const spacing = {
  // Core spacing
  xs: Platform.OS === 'web' ? baseSpacing.xs * 1.5 : baseSpacing.xs,
  sm: Platform.OS === 'web' ? baseSpacing.sm * 1.5 : baseSpacing.sm,
  md: Platform.OS === 'web' ? baseSpacing.md * 1.5 : baseSpacing.md,
  lg: Platform.OS === 'web' ? baseSpacing.lg * 1.5 : baseSpacing.lg,
  xl: Platform.OS === 'web' ? baseSpacing.xl * 1.5 : baseSpacing.xl,
  xxl: Platform.OS === 'web' ? baseSpacing.xxl * 1.5 : baseSpacing.xxl,
  
  // Screen-specific spacing
  screenPadding: Platform.OS === 'web' ? 32 : 16,
  cardPadding: Platform.OS === 'web' ? 24 : 16,
  sectionSpacing: Platform.OS === 'web' ? 40 : 24,
  
  // Border radius
  borderRadius: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 20,
  },
  
  // Component-specific spacing
  headerHeight: Platform.OS === 'web' ? 80 : 60,
  tabHeight: Platform.OS === 'web' ? 70 : 50,
  cardGap: Platform.OS === 'web' ? 20 : 12,
  listGap: Platform.OS === 'web' ? 16 : 8,
  
  // Additional spacing for components
  buttonPadding: Platform.OS === 'web' ? 16 : 12,
  buttonHeight: Platform.OS === 'web' ? 48 : 44,
  inputPadding: Platform.OS === 'web' ? 16 : 12,
  inputHeight: Platform.OS === 'web' ? 48 : 44,
  cardMargin: Platform.OS === 'web' ? 16 : 12,
};

export const layout = {
  // Screen dimensions
  screen: {
    paddingHorizontal: spacing.screenPadding,
    paddingVertical: spacing.screenPadding,
  },
  
  // Card layout
  card: {
    padding: spacing.cardPadding,
    margin: spacing.cardMargin,
    borderRadius: spacing.borderRadius.lg,
  },
  
  // Button layout
  button: {
    paddingHorizontal: spacing.buttonPadding,
    paddingVertical: spacing.buttonPadding,
    height: spacing.buttonHeight,
    borderRadius: spacing.borderRadius.md,
  },
  
  // Input layout
  input: {
    paddingHorizontal: spacing.inputPadding,
    paddingVertical: spacing.inputPadding,
    height: spacing.inputHeight,
    borderRadius: spacing.borderRadius.md,
  },
};
